// Mock 数据 - 用于模拟抽奖接口
// 启用 Mock 模式：在 useLottery 配置中设置 enableMock: true

import { awardConfig } from '@/config';

// 奖品列表配置
const awardList = [
  { id: 'Thanks', name: awardConfig.Thanks, type: 'sendNothing' },
  { id: 'Title', name: awardConfig.Title, type: 'sendVt' },
  { id: 'Avatar', name: awardConfig.Avatar, type: 'sendVt' },
  { id: 'PhoneHolder', name: awardConfig.PhoneHolder, type: 'sendMaterial' },
  { id: 'CanvasBag', name: awardConfig.CanvasBag, type: 'sendMaterial' },
  { id: 'FridgeMagnet', name: awardConfig.FridgeMagnet, type: 'sendMaterial' },
  { id: 'Calendar', name: awardConfig.Calendar, type: 'sendMaterial' },
  { id: 'WaistPillow', name: awardConfig.WaistPillow, type: 'sendMaterial' },
  { id: 'Headwear', name: awardConfig.Headwear, type: 'sendVt' },
];

/**
 * Mock 抽奖结果
 * @param count 抽奖次数（1 或 10）
 */
export const mockLotteryResult = (count: number = 1) => {
  const results = [];

  for (let i = 0; i < count; i++) {
    // 随机选择一个奖品
    const randomIndex = Math.floor(Math.random() * awardList.length);
    const award = awardList[randomIndex];

    results.push({
      awardId: award.id,
      awardName: award.name,
      awardVtType: award.type, // sendNothing(谢谢参与), sendVt(游戏道具), sendMaterial(实物奖励)
      awardVtId: award.type === 'sendVt' ? `vt_${award.id}_${Date.now()}` : '',
    });
  }

  return {
    result: 1,
    data: {
      lotteryAwardList: results,
    },
    msg: '抽奖成功',
  };
};

/**
 * Mock 活动基础数据
 */
export const mockActivityBasic = () => {
  // 生成当前时间戳（秒级）
  const currentTimestamp = Math.floor(Date.now() / 1000);

  return {
    code: 1,
    result: 1,
    msg: 'success',
    data: {
      timezone: 'UTC+8',
      timestamp: currentTimestamp, // 服务器时间戳
      activityIsStart: 1, // 活动是否已开始 (0: 未开始, 1: 已开始)
      activityIsEnd: 0,   // 活动是否已结束 (0: 未结束, 1: 已结束)
      awardIsStart: 0,    // 领奖是否已开始 (0: 未开始, 1: 已开始)
      awardIsEnd: 0,      // 领奖是否已结束 (0: 未结束, 1: 已结束)
      bindInfo: {
        serverId: 4750226, // 对应服务器列表的 sid（select 的 v-model）
        serverName: '法老王',
        sId: 9, // 另一个服务器 ID
        roleId: '623043',
        roleName: '可愛ム愛麗絲',
      },
      availablePoints: 250,  // 当前可用积分
      reserveStatus: 0,      // 预约状态 (0: 未预约, 1: 已预约)
      teamCode: 'ABCD1234',  // 队伍邀请码（myCode）
      membersCount: 5,       // 队伍人数
    },
  };
};

/**
 * Mock 我的奖品列表
 */
export const mockMyAwards = () => {
  return {
    result: 1,
    data: {
      virtualAwards: [
        {
          id: 1,
          awardId: 1,
          awardName: '金色波利帽',
          awardType: 1,
          awardImage: 'award1.png',
          claimStatus: 0,
          giftCode: '',
          createdAt: '2024-03-01 10:00:00',
        },
        {
          id: 2,
          awardId: 2,
          awardName: '神秘礼包',
          awardType: 1,
          awardImage: 'award2.png',
          claimStatus: 1,
          giftCode: 'ABCD-EFGH-1234',
          createdAt: '2024-03-02 11:00:00',
        },
      ],
      materialAwards: [
        {
          id: 3,
          awardId: 10,
          awardName: 'RO手办',
          awardType: 2,
          awardImage: 'award10.png',
          claimStatus: 0,
          shippingInfo: null,
          createdAt: '2024-03-03 12:00:00',
        },
      ],
    },
    msg: '获取成功',
  };
};

/**
 * Mock 领取虚拟奖品
 */
export const mockClaimVirtualReward = (awardId: number) => {
  // 模拟生成礼包码
  const giftCode = `RO${Math.random().toString(36).substring(2, 10).toUpperCase()}`;

  return {
    result: 1,
    data: {
      giftCode,
      awardId,
      claimTime: new Date().toISOString(),
    },
    msg: '领取成功',
  };
};

/**
 * Mock 领取实物奖品（填写地址）
 */
export const mockClaimMaterialReward = (awardId: number, shippingInfo: any) => {
  return {
    result: 1,
    data: {
      awardId,
      shippingInfo,
      claimTime: new Date().toISOString(),
      trackingNumber: '', // 物流单号（后续发货后填写）
    },
    msg: '提交成功，我们将尽快为您发货',
  };
};

/**
 * Mock 用户登录信息
 */
export const mockUserInfo = (isLogin: boolean = true) => {
  if (!isLogin) {
    return {
      result: 0,
      msg: '未登录',
    };
  }

  return {
    result: 1,
    data: {
      LOGIN_ACCOUNT: 'test_user_123',
      USER_ID: '123456',
      NICKNAME: '测试用户',
      AVATAR: '',
    },
    msg: '获取成功',
  };
};

/**
 * Mock 错误响应
 */
export const mockError = (code: number) => {
  const errorMessages: Record<number, string> = {
    21018: '积分不足',
    21019: '抽奖失败',
    21022: '活动未结束',
    21023: '无可领取的实物奖励',
    21024: '领取实物奖励失败',
    21027: '没有可领取的虚拟奖励',
  };

  return {
    result: 0,
    code,
    msg: errorMessages[code] || '操作失败',
  };
};

/**
 * Mock 延迟函数 - 模拟网络请求延迟
 */
export const mockDelay = (ms: number = 500) => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

// ========== 任务相关 Mock ==========

/**
 * Mock 任务列表 - 新接口格式 (refreshTaskCenter)
 */
export const mockTaskList = () => {
  return {
    error: 0,
    msg: "success",
    data: {
      taskList: [
        {
          taskId: "task_daily_login",
          taskType: "game_active",
          subTaskList: [
            {
              subTaskId: "sub_daily_login",
              subTaskType: "add_server",
              resetType: "daily",
              levelType: "fixed_level",
              levelConfigList: [
                {
                  levelId: "level_daily_login_1",
                  level: 1,
                  status: "1", // "0"-未完成, "1"-已完成, "2"-已领取
                  taskKey: "12345"
                }
              ],
              limitConfig: {
                limitSwitch: 1,
                limitData: [
                  { limitType: "daily", limitValue: 1 }
                ]
              }
            }
          ]
        },
        {
          taskId: "task_daily_share",
          taskType: "platform_active",
          subTaskList: [
            {
              subTaskId: "sub_daily_share",
              subTaskType: "share_center",
              resetType: "daily",
              levelType: "fixed_level",
              levelConfigList: [
                {
                  levelId: "level_daily_share_1",
                  level: 1,
                  status: "0",
                  taskKey: ""
                }
              ],
              limitConfig: {
                limitSwitch: 1,
                limitData: [
                  { limitType: "daily", limitValue: 1 }
                ]
              }
            }
          ]
        },
        {
          taskId: "task_reserve_external",
          taskType: "platform_active",
          subTaskList: [
            {
              subTaskId: "sub_reserve_external",
              subTaskType: "reserve_external",
              resetType: "activity",
              levelType: "fixed_level",
              levelConfigList: [
                {
                  levelId: "level_reserve_ext_1",
                  level: 1,
                  status: "2",
                  taskKey: "12347"
                }
              ],
              limitConfig: {
                limitSwitch: 1,
                limitData: [
                  { limitType: "activity", limitValue: 1 }
                ]
              }
            }
          ]
        },
        {
          taskId: "task_team_rally",
          taskType: "team",
          subTaskList: [
            {
              subTaskId: "sub_team_member",
              subTaskType: "team_member_count",
              resetType: "activity",
              levelType: "customize_level",
              levelConfigList: [
                {
                  levelId: "level_team_3",
                  level: 3,
                  status: "1",
                  taskKey: "12348"
                },
                {
                  levelId: "level_team_5",
                  level: 5,
                  status: "1",
                  taskKey: "12349"
                },
                {
                  levelId: "level_team_7",
                  level: 7,
                  status: "0",
                  taskKey: ""
                },
                {
                  levelId: "level_team_10",
                  level: 10,
                  status: "0",
                  taskKey: ""
                }
              ],
              limitConfig: {
                limitSwitch: 1,
                limitData: [
                  { limitType: "activity", limitValue: 1 }
                ]
              }
            }
          ]
        }
      ]
    }
  };
};

/**
 * Mock 完成任务
 */
export const mockCompleteTask = (taskKey: string) => {
  // 模拟不同任务的积分奖励
  const taskScores: Record<string, number> = {
    dailyLogin: 5,
    advanceReservation: 25,
    provideFeedback: 15,
    submitRoMemory: 15,
    submitCostumeDesign: 25,
    submitPhoto: 25,
    likeOthersUgc: 0.5,
    likeMyUgc: 1,
    joinFb: 10,
    joinDc: 10,
    joinYtb: 10,
    joinLine: 10,
  };

  const earnedScore = taskScores[taskKey] || 0;

  return {
    result: 1,
    data: {
      taskKey,
      earnedScore,
      totalScore: 250 + earnedScore, // 假设原有250积分
      completed: true,
    },
    msg: `任务完成！获得 ${earnedScore} 积分`,
  };
};

// ========== 里程碑相关 Mock ==========

/**
 * Mock 获取服务器时间
 */
export const mockGetTime = () => {
  // 返回当前时间戳（秒级）
  const currentTimestamp = Math.floor(Date.now() / 1000);

  return {
    result: 1,
    data: currentTimestamp,
    msg: 'success',
  };
};

